export default {
  launchArguments: {},
};
